/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CurrentInhibitionInfosPage } from '../../models/current-inhibition-infos-page';

export interface GetCurrentInhibitions$Params {

/**
 * The list items limit
 */
  limit?: number;

/**
 * The list items offset
 */
  offset?: number;
}

export function getCurrentInhibitions(http: HttpClient, rootUrl: string, params?: GetCurrentInhibitions$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentInhibitionInfosPage>> {
  const rb = new RequestBuilder(rootUrl, getCurrentInhibitions.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CurrentInhibitionInfosPage>;
    })
  );
}

getCurrentInhibitions.PATH = '/custom/alarms/inhibitions/current';
